import styled from 'styled-components'

import { style } from 'theme'

const Heading = styled.h2`
  color: ${style(theme => theme.colors.slate)};
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0;
`

export default Heading
